export default {
  meta: {
    title: 'POI地图',
    url: '/selection/poimap', // 埋点用，记录所属模块
    // eventId: 'b43ce415-9e54-4446-add8-a4ed531f2dd3'
  },
};
